export default "__VITE_ASSET__CEF0Sorf__"